import type { ReportDefinitionChannel } from './api';

/** Como o canal de um conjunto aparece no selo. */
export class ReportChannel {
  private static readonly LABELS: Record<ReportDefinitionChannel, string> = {
    whatsapp: 'WhatsApp',
    email: 'E-mail',
  };

  static label(channel: ReportDefinitionChannel): string {
    return ReportChannel.LABELS[channel];
  }
}
